import React from "react";
import PropTypes from "prop-types";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import "./custom-styling.css";

//Components
import BlockContent from "../richText";

//Styles
import * as styles from "./modal.module.scss";

const EpModal = ({ data, onCloseModal }) => {
  return (
    <div>
      <Modal
        open={data.isOpen}
        onClose={onCloseModal}
        center
        showCloseIcon={data.isOpen}
        animationDuration={500}
        classNames={{
          modal: "customModal",
        }}
      >
        <div className={styles.modalWrapper}>
          <BlockContent
            blocks={data.richText}
            customClassName={styles.gridImgTextContainer}
          />
        </div>
      </Modal>
    </div>
  );
};

export default EpModal;

EpModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  data: PropTypes.shape({
    isOpen: PropTypes.bool.isRequired,
    richText: PropTypes.array,
  }),
};
